import { BrowserRouter } from "react-router-dom";
import { useRoutes } from "react-router-dom";
import routes from "./router/config";
import AuthGuard from "./components/feature/AuthGuard";
import { AuthProvider } from "./context/AuthContext";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "./LanguageSwitcher";

function AppRoutes() {
  const element = useRoutes(routes);
  return element;
}

function App() {
  const { t } = useTranslation();

  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AuthProvider>
        <AuthGuard>
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />

          <AppRoutes />
        </AuthGuard>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
